import React, { createContext, useState, useContext, useEffect } from "react";
import EnglishJson from "../language/en.json";
import GermanJson from "../language/de.json";
import SpainJson from "../language/es.json";
import FarsiJson from "../language/fa.json";
import FranceJson from "../language/fr.json";
import PortugalJson from "../language/pt.json";
import RussianJson from "../language/ru.json";
import TurkeyJson from "../language/tr.json";
import ChinaJson from "../language/zh.json";
import { useTranslation } from "react-i18next";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState("en");
  const [activeLanguage, setActiveLanguage] = useState(false);
  const [hostLanguage, setHostLanguage] = useState("de");
  const [languageJson, setLanguageJson] = useState(GermanJson);

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    switch (newLanguage) {
      case "en":
        setHostLanguage("en");
        setLanguageJson(EnglishJson);
        i18n.changeLanguage("en");
        break;
      case "es":
        setHostLanguage("es");
        setLanguageJson(SpainJson);
        i18n.changeLanguage("es");
        break;
      case "fa":
        setHostLanguage("fa");
        setLanguageJson(FarsiJson);
        i18n.changeLanguage("fa");
        break;
      case "fr":
        setHostLanguage("fr");
        setLanguageJson(FranceJson);
        i18n.changeLanguage("fr");
        break;
      case "pt":
        setHostLanguage("pt");
        setLanguageJson(PortugalJson);
        i18n.changeLanguage("pt");
        break;
      case "ru":
        setHostLanguage("ru");
        setLanguageJson(RussianJson);
        i18n.changeLanguage("ru");
        break;
      case "tr":
        setHostLanguage("tr");
        setLanguageJson(TurkeyJson);
        i18n.changeLanguage("tr");
        break;
      case "zh":
        setHostLanguage("zh");
        setLanguageJson(ChinaJson);
        i18n.changeLanguage("zh");
        break;

      default:
      case "de":
        setHostLanguage("de");
        setLanguageJson(GermanJson);
        i18n.changeLanguage("de");
        break;
    }
  };

  const setActivateLanguage = (isActive) => {
    setActiveLanguage(isActive);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, activeLanguage, setActivateLanguage, hostLanguage, setHostLanguage, languageJson }}>
      {children}
    </LanguageContext.Provider>
  );
};

export function useLangContext() {
  return useContext(LanguageContext);
}
